@if(!dataLoaded()){
<div
  class="container flex flex-row justify-center items-center"
  style="height: 100vh"
>
  <span class="fs-3 mr-5">Verifying Account</span>
  <span class="text-xl spinner-border spinner-border-lg align-middle"></span>
</div>
}@else {
<!--  -->
@if(successVisible()){
<div class="container flex flex-col justify-center items-center">
  <i class="text-xl fa-solid fa-circle-check mb-4 text-primary"></i>
  <span class="fs-3 mr-5 mb-4">Account verification completed!</span>
  <div class="word-break text-center mb-6">
    Your account is now verified. You can log in to explore all the features and
    start using the app!
  </div>
  <button
    class="!text-white"
    pButton
    severity="primary"
    (click)="router.navigate(['/'])"
  >
    Continue
  </button>
</div>
}@else if(errorVisible()){
<div class="container flex flex-col justify-center items-center">
  <i class="text-xl fa-solid fa-circle-xmark mb-4 text-danger"></i>
  <span class="fs-3 mr-5 mb-4">Account verification failed!</span>
  <div class="word-break text-center mb-6">
    Your account is already verified. You can log in anytime to explore the app
    and enjoy all the features!
  </div>
  <button
    class="!text-white"
    pButton
    severity="primary"
    (click)="router.navigate(['/'])"
  >
    Continue
  </button>
</div>
} }
